<template>
    <div class="page-head">
        <div class="container">
            <div class="row">
                <div class="page-head-content">
                    <h1 class="page-title"><span class="orange strong">{{agencyId ? agency ? agency.name : '' : 'You are not joined to agency yet'}}</span></h1>
                </div>
            </div>
        </div>
    </div>

    <div class="content-area user-profiel"  >&nbsp;
        <div class="container">

            <div class="row" v-if="!agencyId">
                <div class="col-md-12 alert-message">
                    <p><i class="fa fa-exclamation-triangle"></i> <span>You are not joined to agency! to be part of an agency either create your first ad or search of specific agency in <router-link to="/agency-search">agency search</router-link> and join it</span></p>
                </div>
            </div>

            <div v-else>
                <div class="row" v-if="!loading && agency">
                    <div class="col-lg-4">
                        <div class="card mb-4">
                            <div class="card-body text-center">
                                <img :src="agency.picture_url" :alt="agency.name" onerror="this.src='/template/assets/img/user-icon.png'" class="rounded-circle img-fluid" style="width: 150px;">
                                <h5 class="my-3">{{agency.name}}</h5>
                                <p class="text-muted mb-1" v-if="agency.created_at">{{getCreatedAt(agency.created_at)}}</p>
                                <p class="text-muted mb-4">{{agency.address}}</p>
                                <p>Role: {{agency.agency_owner_id == user.id ? 'Administrator' : 'Member'}}</p>
                                <div class="d-flex justify-content-center mb-2" v-if="agency.agency_owner_id == user.id">
                                    <button type="button" class="btn btn-sm btn-info" v-on:click="editAgency"><i class="fa fa-edit"></i> Edit</button>
                                </div>
                                <div class="d-flex justify-content-center mb-2" v-if="agency.agency_owner_id !== user.id">
                                    <button type="button" class="btn btn-sm btn-primary" v-on:click="leaveAgency"><i class="fa fa-edit"></i> Leave Agency</button>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-4 mb-lg-0">
                            <div class="card-body p-0">
                                <ul class="list-group list-group-flush rounded-3">
                                    <li class="list-group-item d-flex justify-content-between align-items-center p-3" v-if="agency.facebook">
                                        <i class="fa fa-facebook" style="color: #1096f4"></i>
                                        <a :href="agency.facebook" target="_blank"><p class="mb-0">{{agency.facebook}}</p></a>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center p-3" v-if="agency.twitter">
                                        <i class="fa fa-twitter" style="color: #1096f4;"></i>
                                        <a :href="agency.twitter" target="_blank"><p class="mb-0">{{agency.twitter}}</p></a>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center p-3" v-if="agency.google">
                                        <i class="fa fa-google" style="color: #4285f4;"></i>
                                        <a :href="agency.google" target="_blank"><p class="mb-0">{{agency.google}}</p></a>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center p-3" title="website" v-if="agency.website">
                                        <i class="fa fa-globe"></i>
                                        <a :href="agency.website" target="_blank"><p class="mb-0">{{agency.website}}</p></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <div class="card mb-4">
                            <div class="card-body">
                                <div class="row" v-if="agency.bio">
                                    <div class="col-sm-3">
                                        <p class="mb-0">Bio</p>
                                    </div>
                                    <div class="col-sm-9">
                                        <p class="text-muted mb-0">{{agency.bio}}</p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-sm-3">
                                        <p class="mb-0">Email</p>
                                    </div>
                                    <div class="col-sm-9">
                                        <p class="text-muted mb-0">{{agency.email}}</p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-sm-3">
                                        <p class="mb-0">Phone</p>
                                    </div>
                                    <div class="col-sm-9">
                                        <p class="text-muted mb-0">{{agency.phone}}</p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-sm-3">
                                        <p class="mb-0">Address</p>
                                    </div>
                                    <div class="col-sm-9">
                                        <p class="text-muted mb-0">{{agency.address}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="row" v-else>
                    <div class="col-md-12">
                        <div class="fa-3x">
                            <i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ref} from "vue";
import moment from "moment";
import {useRoute, useRouter} from "vue-router";
import {useAuthStore} from "../../../store/auth";
import {useToast} from "vue-toastification";

export default {
    name: "AgencyProfile",
    setup() {
        const route = useRoute();
        const router = useRouter();
        const toast = useToast();

        const auth = useAuthStore();

        const agencyId = auth.$state.user.agency_id
        const agency = ref(null);
        const loading = ref(false);


        const getAgencyDetail = () => {

            if(!agencyId) {
                return;
            }

            loading.value = true;

            window.axios.get(`/api/agency/${agencyId}`).then(response => {
                loading.value = false;

                agency.value = response.data.agency;
            }).catch(err=> {
                loading.value = false;
            });
        }

        getAgencyDetail();

        const getCreatedAt = (created_at) => {
            return moment(created_at).format('DD MMM YYYY');
        }

        const editAgency = () => {
            router.push('/user/edit-agency');
        }

        const leaveAgency = () => {
            window.axios.post(`/api/agency/leave/${auth.$state.user.id}/${agencyId}`).then(response => {

                toast.success(response.data.message);

                router.push('/user/profile');

                auth.updateUser({...auth.$state.user, agency_id: null});
            }).catch(err=> {
                toast.error(err.response.data.message);
            });
        }

        return {
            getCreatedAt,
            agency,
            loading,
            agencyId,
            user: auth.$state.user,
            editAgency,
            leaveAgency
        }
    }
}
</script>
<style scoped>
.profiel-container {
    padding: 10px 5px;
}

.alert-message .fa {
    color: orange;
    font-size: 50px;
}

.alert-message span {
    font-size: 15px;
    font-weight: bold;
}
</style>
